// getIsShortVideo.js
'use strict';

/**
 * Check whether a video counts as a short video.
 * A duration is rounded down to whole seconds first, so a video reported as
 * 60.9 seconds counts the same as one reported as 60 seconds.
 * @param {object} options
 * @param {number} options.duration - The video duration in seconds.
 * @param {number} options.shortVideoMaxSeconds - The longest duration, in
 *   seconds, that still counts as a short video.
 * @returns {boolean} Return true if the video counts as a short video.
 * @example
 * getIsShortVideo({ duration: 60.9, shortVideoMaxSeconds: 60 });
 * // => true
 * getIsShortVideo({ duration: 61, shortVideoMaxSeconds: 60 });
 * // => false
 */
const getIsShortVideo = ({ duration, shortVideoMaxSeconds }) =>
  Math.floor(duration) <= shortVideoMaxSeconds;

export default getIsShortVideo;
